import { h, Component } from 'preact';
import { translate } from 'react-i18next';

import Button from './Button.js';


class TwoFactorBackupEmail extends Component {
	
	addEmail = () => {
		this.setState({ buttonEnterEmail: 'loading' });
		if (this.state.email) {
			if (this.state.email !== this.props.accountEmail) {
				fetch('https://api.hirezstudios.com/acct/setBackupEmail', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.userData.webToken}", "email": "${this.state.email}"}`
				}).then((response) => response.json()).then((response) => {
					this.setState({ 
						buttonEnterEmail: 'initial',
						errorEnterEmail: undefined
					});
					if (response.statusCode === 200) {
						this.setState({ step: 'verify' });
					}
					else {
						this.setState({ errorEnterEmail: 'Please check your recovery email and try again.' });
					}
				})
			}
			else {
				this.setState({
					buttonEnterEmail: 'initial',
					errorEnterEmail: 'Your recovery email cannot be the same as your account email.'
				});
			}
		}
		else {
			this.setState({
				buttonEnterEmail: 'initial',
				errorEnterEmail: 'An email address is required.'
			});
		}
	}

	verifyEmail = () => {
  	this.setState({ buttonVerifyEmail: 'loading' });
  	if (this.state.emailCode) {
			fetch('https://api.hirezstudios.com/acct/verifyBackupEmail', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.userData.webToken}", "key": "${this.state.emailCode}"}`
				}).then((response) => response.json()).then((response) => {
					this.setState({ buttonVerifyEmail: 'initial' });
					if (response.statusCode === 200) {
						this.setState({ step: 'confirmed' });
						this.props.update('newEmail',this.state.email);
					} else {
						this.setState({ errorVerifyEmail: 'Please check your validation code and try again.' });
					}
				})
  		// fetch api endpoint on success
  		this.setState({
				buttonVerifyEmail: 'initial',
				step: 'initial',
				errorVerifyEmail: undefined,
				emailCode: undefined
			});
  	}
  	else {
			this.setState({ 
				buttonVerifyEmail: 'initial',
				errorVerifyEmail: 'A verification code is required.'
			});
  	}
	}
	
	cancelVerify = () => {
  	this.setState({
			step: 'initial',
			email: undefined,
			emailCode: undefined,
			errorVerifyEmail: undefined
		});
	}

	constructor(props) {
		super(props);
		this.state = {
			step: 'initial',
			buttonEnterEmail: 'initial',
			buttonVerifyEmail: 'initial'
		};
	}

	shouldComponentUpdate(nextProps) {
    if ( nextProps.twoFactorData !== undefined && this.state.currentEmail === undefined ) {
      this.setState({currentEmail: nextProps.twoFactorData.backupEmail !== null ? nextProps.twoFactorData.backupEmail.toLowerCase() : '' });
    }
  }

  componentDidMount() {
      this.setState({ currentEmail: this.props.twoFactorData.backupEmail !== null ? this.props.twoFactorData.backupEmail.toLowerCase() : '' });
  }

	render() {
		const { t } = this.props;
		return (
			<div className="c-TwoFactorBackupEmail">
				<h4>{t('E-Mail Verification Settings')}</h4>
				<p>{t('The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.')}</p>
				{ this.state.step === 'initial' && this.state.currentEmail !== undefined &&
					<div className="current-email-notification">{t(`Currently using ${this.state.currentEmail} as your recovery e-mail.`)}</div>
				}
				{ this.state.step === 'initial' &&
            <div>
            	<div className="enter-email">
            		<label>{t('Recovery E-Mail:')}</label>
            		<div className="input-wrapper">
									<input
										id="enter-email"
										type="text"
										onInput={e => this.setState({ email: e.target.value })}
										value={this.state.email}
									/>
            			<div className="error-enter-email">{t(this.state.errorEnterEmail)}</div>
            		</div>
            	</div>
            	<div className="buttons-wrapper">
								<Button
									color="blue"
									copy={t('Next')}
									state={this.state.buttonEnterEmail}
									onClick={this.addEmail}
								/>
            	</div>
            </div>
				}
				{ this.state.step === 'verify' &&
            <div>
            	<div className="verify-email">
            		<label>{t('Verification Code:')}</label>
            		<div className="input-wrapper">
									<input
										id="verify-email"
										type="text"
										onInput={e => this.setState({ emailCode: e.target.value })}
										value={this.state.emailCode}
									/>
            			<div className="error-verify-email">{t(this.state.errorVerifyEmail)}</div>
            		</div>
            	</div>
            	<div className="buttons-wrapper">
								<Button
									color="blue"
									copy={t('Verify')}
									state={this.state.buttonVerifyEmail}
									onClick={this.verifyEmail}
								/>
								<Button
									copy={t('Cancel')}
									onClick={this.cancelVerify}
								/>
            	</div>
            </div>
				}
				{ this.state.step === 'confirmed' &&
					<div>
						<div className="confirmed-email">
							<div className="confirm-message">{t('You\'ve successfully verified your backup email address.')} <a onClick={this.cancelVerify}>{t('Click here')}</a> {t('to add a backup email address.')}</div>
						</div>
					</div>
				}
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(TwoFactorBackupEmail);


// WEBPACK FOOTER //
// ./components/TwoFactorBackupEmail.js